/**
 * Перелік розділів системних даних платформи — спільне джерело для лівого
 * меню (PlatformLayout) і сторінки (PlatformSystemDataPage).
 *
 * Згруповано за темами для зручної навігації у sidebar.
 */

export type PlatformSectionId =
  | 'currencies'
  | 'vat-rates'
  | 'banks'
  | 'tax-constants'
  | 'classifiers'
  | 'calendar'
  | 'income-types'
  | 'dismissal-grounds'
  | 'inflation'
  | 'worktime'
  | 'disability'
  | 'tax-list';

export interface PlatformSection {
  id: PlatformSectionId;
  label: string;
}

export interface PlatformSectionGroup {
  title: string;
  sections: PlatformSection[];
}

export const PLATFORM_SECTION_GROUPS: PlatformSectionGroup[] = [
  {
    title: 'Фінансові',
    sections: [
      { id: 'currencies', label: 'Валюти' },
      { id: 'vat-rates', label: 'Ставки ПДВ' },
      { id: 'banks', label: 'Банки' },
      { id: 'tax-list', label: 'Перелік податків' },
    ],
  },
  {
    title: 'Податки та облік',
    sections: [
      { id: 'tax-constants', label: 'Податкові константи' },
      { id: 'classifiers', label: 'Класифікатори' },
      { id: 'income-types', label: 'Ознаки доходів (4ДФ)' },
      { id: 'inflation', label: 'Індекс інфляції' },
    ],
  },
  {
    title: 'Кадри та час',
    sections: [
      { id: 'calendar', label: 'Виробничий календар' },
      { id: 'worktime', label: 'Коди робочого часу (П-5)' },
      { id: 'disability', label: 'Причини непрацездатності' },
      { id: 'dismissal-grounds', label: 'Підстави звільнення' },
    ],
  },
];

// Плоский список (для валідації/пошуку).
export const PLATFORM_SECTIONS: PlatformSection[] =
  PLATFORM_SECTION_GROUPS.flatMap((g) => g.sections);

export const DEFAULT_PLATFORM_SECTION: PlatformSectionId = 'currencies';

export function isPlatformSection(v: string | null): v is PlatformSectionId {
  return PLATFORM_SECTIONS.some((s) => s.id === v);
}
